module.exports = __webpack_public_path__ + "static/media/file_download.a47dbd23.svg";